const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const codeContainer = path.resolve('src/containers/Code/index.js')

  return createPage({
    path: router(route.path, {}),
    component: codeContainer,
    context: {
      isVip: !!route.isVip,
    },
  })
}
